import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { CancelOfferResponse, cancelOffer } from '@utils/backend-api/cancelOffer';

export default function useCancelOffer() {
  const { mutate, isLoading, isError } = useMutation(() => cancelOffer(), {
    onSuccess: (data: CancelOfferResponse) => {
      if (data.redirectUri) {
        window.location.href = data.redirectUri;
      }
    },
    onError: (data: CancelOfferResponse) => {
      toast.error(data?.message ?? 'Your offer update failed, please try again later');
    },
  });
  return { mutate, isLoading, isError };
}
